window.addEventListener('DOMContentLoaded', function () {
  if (!(document.URL == "https://qonto.com/fr/blog")) { return; }

  $("body > section.section-card-list > div > div:nth-child(3) > div:nth-child(3)").hide();
  $("body > section.section-card-list > div > div:nth-child(3) ").append(`
  <div class="card-sponsored-post card-color-grey">
    <a target="_blank" href="https://qonto.com/fr/team/livre-blanc" rel="noopener">
      <div class="image-container">
        <img src="https://images.prismic.io/qontoblog/62af9ec9-693d-4351-878a-e26a598e7d3a_Sponsored_post_white_paper_5.png?auto=compress,format"
          srcset="https://images.prismic.io/qontoblog/62af9ec9-693d-4351-878a-e26a598e7d3a_Sponsored_post_white_paper_5.png?auto=compress%2Cformat&amp;dpr=1&amp;q=55&amp;w=1024 1x,
          https://images.prismic.io/qontoblog/62af9ec9-693d-4351-878a-e26a598e7d3a_Sponsored_post_white_paper_5.png?auto=compress%2Cformat&amp;dpr=2&amp;q=25&amp;w=1024 2x,
          https://images.prismic.io/qontoblog/62af9ec9-693d-4351-878a-e26a598e7d3a_Sponsored_post_white_paper_5.png?auto=compress%2Cformat&amp;dpr=3&amp;q=15&amp;w=1024 3x"
          alt="Livre ouvert avec une couverture violette." />
      </div>
    </a>
  </div>
  `);
});
